import {
  GET_CASHBOOK_PARTY_HEADS,
  GET_CASHBOOK_PARTY_HEADS_SUCCESS,
  SAVE_CASHBOOK_PARTY_HEAD,
  SAVE_CASHBOOK_PARTY_HEAD_SUCCESS,
  CASHBOOK_ENTRY_API_ERROR_ACTION,
  GET_CASHBOOK_ENTRY_LIST,
  GET_CASHBOOK_ENTRY_LIST_SUCCESS,
  EDIT_CASHBOOK_ENTRY_ID,
  EDIT_CASHBOOK_ENTRY_ID_SUCCESS,
  UPDATE_CASHBOOK_ENTRY_ID,
  UPDATE_CASHBOOK_ENTRY_ID_SUCCESS,
  DELETE_CASHBOOK_ENTRY_ID_SUCCESS,
  DELETE_CASHBOOK_ENTRY_ID,
} from "./actionTypes";

export const getCashBookPartyHeads = (partyId) => ({ // get party wise heads Action
  type: GET_CASHBOOK_PARTY_HEADS,
  partyId,
});

export const getCashBookPartyHeadsSuccess = (data) => ({ // get party wise heads Success
  type: GET_CASHBOOK_PARTY_HEADS_SUCCESS,
  payload: data,
});

export const saveCashBookPartyHead = (config = {}) => ({ // save Action
  type: SAVE_CASHBOOK_PARTY_HEAD,
  config,
});

export const saveCashBookPartyHead_Success = (resp) => ({ // save Success
  type: SAVE_CASHBOOK_PARTY_HEAD_SUCCESS,
  payload: resp,
});

export const cashBookEntryApiErrorAction = () => ({
  type: CASHBOOK_ENTRY_API_ERROR_ACTION,
});

export const getCashBookEntryList = (config = {}) => ({ // list Action
  type: GET_CASHBOOK_ENTRY_LIST,
  config,
});

export const getCashBookEntryListSuccess = (data) => ({ // list Success
  type: GET_CASHBOOK_ENTRY_LIST_SUCCESS,
  payload: data,
});

export const editCashBookEntryID = (config = {}) => ({ // edit Action
  type: EDIT_CASHBOOK_ENTRY_ID,
  config,
});

export const editCashBookEntryIDSuccess = (data) => ({ // edit Success
  type: EDIT_CASHBOOK_ENTRY_ID_SUCCESS,
  payload: data,
});

export const updateCashBookEntryID = (config = {}) => ({ // update Action
  type: UPDATE_CASHBOOK_ENTRY_ID,
  config,
});

export const updateCashBookEntryIDSuccess = (data) => ({ // update Success
  type: UPDATE_CASHBOOK_ENTRY_ID_SUCCESS,
  payload: data,
});

export const deleteCashBookEntryID = (config = {}) => ({
    type: DELETE_CASHBOOK_ENTRY_ID,
    config,
});

export const deleteCashBookEntryIDSuccess = (data) => ({
    type: DELETE_CASHBOOK_ENTRY_ID_SUCCESS,
    payload: data,
});